/**
 * Telegram platforms enum
 * @see https://docs.telegram-mini-apps.com/platform/launch-parameters
 */
export enum TelegramPlatformEnum {
    Android = 'android',
    iOS = 'ios',
    MacOS = 'macos',
    TDesktop = 'tdesktop',
    WebA = 'weba',
    Web = 'web',
}
